var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66683 4.3335H7.00016V0.333496H3.00016V4.3335H0.333496L5.00016 9.00016L9.66683 4.3335ZM4.3335 5.66683V1.66683H5.66683V5.66683H6.44683L5.00016 7.1135L3.5535 5.66683H4.3335ZM0.333496 10.3335H9.66683V11.6668H0.333496V10.3335Z",
    fill: "#6271DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.a9e4ff8df86d3b8b3e315efd1398dabe.svg";
export { ForwardRef as ReactComponent };